import prop from 'vue-strict-prop'
import { componentFactoryOf } from 'vue-tsx-support'

interface Events {
	onClick(e: MouseEvent): void
}

export default componentFactoryOf<Events>().create({
	name: 'Button',
	props: {
		attached: prop.ofStringLiterals('bottom', 'left', 'right', 'top').optional,
		disabled: prop(Boolean).default(false),
		icon: prop(String).optional,
		labeled: prop(Boolean, String)
			.validator(v => typeof v === 'boolean' || v === 'right')
			.optional,
		loading: prop(Boolean).optional,
		type: prop.ofStringLiterals('button', 'reset', 'submit').default('button'),
	},
	methods: {
		onClick(e: MouseEvent): void {
			this.$emit('click', e)
		},
	},
	render() {
		const { attached, icon, labeled, loading } = this
		return (
			<button
				class={['ui button', { attached, icon, right: labeled === 'right', labeled: !!labeled, loading }]}
				disabled={this.disabled}
				onClick={this.onClick}
				type={this.type}
				>
				{!!icon && <i class={[icon, 'icon']} />}
				{this.$slots.default}
			</button>
		)
	},
})
